import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    softener_history_event_0000: {
      id: 'softener_history_event_0000',
      defaultMessage: "Saved. Time 00:00:00",
      description: '',
    },
    softener_history_event_0001: {
      id: 'softener_history_event_0001',
      defaultMessage: "Saved. Time 06:00:00",
      description: '',
    },
    softener_history_event_0002: {
      id: 'softener_history_event_0002',
      defaultMessage: "Saved. Time 12:00:00",
      description: '',
    },
    softener_history_event_0003: {
      id: 'softener_history_event_0003',
      defaultMessage: "Saved. Time 18:00:00",
      description: '',
    },
    softener_history_event_0004: {
      id: 'softener_history_event_0004',
      defaultMessage: "Valve 1 mechanism fault",
      description: '',
    },
    softener_history_event_0005: {
      id: 'softener_history_event_0005',
      defaultMessage: "Valve 2 mechanism fault",
      description: '',
    },
    softener_history_event_0006: {
      id: 'softener_history_event_0006',
      defaultMessage: "Valve 3 mechanism fault",
      description: '',
    },
    softener_history_event_0007: {
      id: 'softener_history_event_0007',
      defaultMessage: "Pressure sensor fault",
      description: '',
    },
    softener_history_event_0008: {
      id: 'softener_history_event_0008',
      defaultMessage: "Power ON",
      description: '',
    },
    softener_history_event_0009: {
      id: 'softener_history_event_0009',
      defaultMessage: "Power OFF",
      description: '',
    },
    softener_history_event_0010: {
      id: 'softener_history_event_0010',
      defaultMessage: "Pressure below 1,5 bar (low pressure warning)",
      description: '',
    },
    softener_history_event_0011: {
      id: 'softener_history_event_0011',
      defaultMessage: "Pressure increase by 1 bar",
      description: '',
    },
    softener_history_event_0012: {
      id: 'softener_history_event_0012',
      defaultMessage: "Pressure decrease by 1 bar",
      description: '',
    },
    softener_history_event_0013: {
      id: 'softener_history_event_0013',
      defaultMessage: "Pressure over 8 bar (high pressure warning)",
      description: '',
    },
    softener_history_event_0014: {
      id: 'softener_history_event_0014',
      defaultMessage: "Controller's memory refreshment",
      description: '',
    },
    softener_history_event_0020: {
      id: 'softener_history_event_0020',
      defaultMessage: "No salt detected during the regeneration",
      description: '',
    },
    softener_history_event_0021: {
      id: 'softener_history_event_0021',
      defaultMessage: "Chlor current measurement",
      description: '',
    },
    softener_history_event_0022: {
      id: 'softener_history_event_0022',
      defaultMessage: "No salt' message confirmation",
      description: '',
    },
    softener_history_event_0030: {
      id: 'softener_history_event_0030',
      defaultMessage: "Holiday mode cancel",
      description: '',
    },
    softener_history_event_0031: {
      id: 'softener_history_event_0031',
      defaultMessage: "Holiday mode cancel from the water flow",
      description: '',
    },
    softener_history_event_0032: {
      id: 'softener_history_event_0032',
      defaultMessage: "Holiday mode cancel by user",
      description: '',
    },
    softener_history_event_0040: {
      id: 'softener_history_event_0040',
      defaultMessage: "Connected to LAN network",
      description: '',
    },
    softener_history_event_0041: {
      id: 'softener_history_event_0041',
      defaultMessage: "Disconnected from LAN network",
      description: '',
    },
    softener_history_event_0042: {
      id: 'softener_history_event_0042',
      defaultMessage: "Asigned IP address from the DHCP server",
      description: '',
    },
    softener_history_event_0043: {
      id: 'softener_history_event_0043',
      defaultMessage: "Manually assigned network parameters",
      description: '',
    },
    softener_history_event_0044: {
      id: 'softener_history_event_0044',
      defaultMessage: "User login through Telnet service",
      description: '',
    },
    softener_history_event_0045: {
      id: 'softener_history_event_0045',
      defaultMessage: "Online service connection",
      description: '',
    },
    softener_history_event_0046: {
      id: 'softener_history_event_0046',
      defaultMessage: "Direct computer connection",
      description: '',
    },
    softener_history_event_0047: {
      id: 'softener_history_event_0047',
      defaultMessage: "Online software update",
      description: '',
    },
    softener_history_event_0049: {
      id: 'softener_history_event_0049',
      defaultMessage: "WLAN-USB module reinitialization",
      description: '',
    },
    softener_history_event_0050: {
      id: 'softener_history_event_0050',
      defaultMessage: "User parameters change (menu level 1)",
      description: '',
    },
    softener_history_event_0051: {
      id: 'softener_history_event_0051',
      defaultMessage: "Service parameters change (menu level 2)",
      description: '',
    },
    softener_history_event_0052: {
      id: 'softener_history_event_0052',
      defaultMessage: "Manufacturer parameters change (menu level 3)",
      description: '',
    },
    softener_history_event_0053: {
      id: 'softener_history_event_0053',
      defaultMessage: "Configuration change",
      description: '',
    },
    softener_history_event_0054: {
      id: 'softener_history_event_0054',
      defaultMessage: "RTC time change (original time)",
      description: '',
    },
    softener_history_event_0055: {
      id: 'softener_history_event_0055',
      defaultMessage: "RTC time change (actual time)",
      description: '',
    },
    softener_history_event_0056: {
      id: 'softener_history_event_0056',
      defaultMessage: "Time zone change",
      description: '',
    },
    softener_history_event_0057: {
      id: 'softener_history_event_0057',
      defaultMessage: "Annual inspection reminder",
      description: '',
    },
    softener_history_event_0058: {
      id: 'softener_history_event_0058',
      defaultMessage: "Annual inspection approved",
      description: '',
    },
    softener_history_event_0059: {
      id: 'softener_history_event_0059',
      defaultMessage: "Communication lost with valve 2",
      description: '',
    },
    softener_history_event_0060: {
      id: 'softener_history_event_0060',
      defaultMessage: "Communication lost with valve 3",
      description: '',
    },
    softener_history_event_0062: {
      id: 'softener_history_event_0062',
      defaultMessage: "Return of the valve communication",
      description: '',
    },
    softener_history_event_1000: {
      id: 'softener_history_event_1000',
      defaultMessage: "Auto regeneration start",
      description: '',
    },
    softener_history_event_1001: {
      id: 'softener_history_event_1001',
      defaultMessage: "Immediate regeneration manual start",
      description: '',
    },
    softener_history_event_1002: {
      id: 'softener_history_event_1002',
      defaultMessage: "Delayed regeneration manual start",
      description: '',
    },
    softener_history_event_1003: {
      id: 'softener_history_event_1003',
      defaultMessage: "Immediate multi-regeneration manual start",
      description: '',
    },
    softener_history_event_1004: {
      id: 'softener_history_event_1004',
      defaultMessage: "Delayed regeneration manual stop",
      description: '',
    },
    softener_history_event_1011: {
      id: 'softener_history_event_1011',
      defaultMessage: "Decrease reserve and reporting the necessity of regeneration A cylinder",
      description: '',
    },
    softener_history_event_1012: {
      id: 'softener_history_event_1012',
      defaultMessage: "Decrease reserve and reporting the necessity of regeneration C cylinder",
      description: '',
    },
    softener_history_event_1013: {
      id: 'softener_history_event_1013',
      defaultMessage: "Decrease reserve and reporting the necessity of regeneration B cylinder",
      description: '',
    },
    softener_history_event_1020: {
      id: 'softener_history_event_1020',
      defaultMessage: "Manual cycle stop (pushing the next cycle)",
      description: '',
    },
    softener_history_event_1021: {
      id: 'softener_history_event_1021',
      defaultMessage: "Manual regeneration stop (press 'NEXT' longer)",
      description: '',
    },
    softener_history_event_1030: {
      id: 'softener_history_event_1030',
      defaultMessage: "Regeneration completed, calculating the reserve",
      description: '',
    },
    softener_history_event_1100: {
      id: 'softener_history_event_1100',
      defaultMessage: "Camshaft valve '0' postion for cylinder A found",
      description: '',
    },
    softener_history_event_1200: {
      id: 'softener_history_event_1200',
      defaultMessage: "Camshaft valve '0' postion for cylinder C found",
      description: '',
    },
    softener_history_event_1300: {
      id: 'softener_history_event_1300',
      defaultMessage: "Camshaft valve '0' postion for cylinder B found",
      description: '',
    },
    softener_history_event_2101: {
      id: 'softener_history_event_2101',
      defaultMessage: "C1 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2102: {
      id: 'softener_history_event_2102',
      defaultMessage: "C2 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2103: {
      id: 'softener_history_event_2103',
      defaultMessage: "C3 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2104: {
      id: 'softener_history_event_2104',
      defaultMessage: "C4 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2105: {
      id: 'softener_history_event_2105',
      defaultMessage: "C5 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2106: {
      id: 'softener_history_event_2106',
      defaultMessage: "C6 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2107: {
      id: 'softener_history_event_2107',
      defaultMessage: "C7 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2108: {
      id: 'softener_history_event_2108',
      defaultMessage: "C8 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2109: {
      id: 'softener_history_event_2109',
      defaultMessage: "C9 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2110: {
      id: 'softener_history_event_2110',
      defaultMessage: "C10 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2111: {
      id: 'softener_history_event_2111',
      defaultMessage: "C11 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2112: {
      id: 'softener_history_event_2112',
      defaultMessage: "C12 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2113: {
      id: 'softener_history_event_2113',
      defaultMessage: "C13 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2114: {
      id: 'softener_history_event_2114',
      defaultMessage: "C14 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2115: {
      id: 'softener_history_event_2115',
      defaultMessage: "C15 cycle for A cylinder",
      description: '',
    },
    softener_history_event_2201: {
      id: 'softener_history_event_2201',
      defaultMessage: "C1 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2202: {
      id: 'softener_history_event_2202',
      defaultMessage: "C2 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2203: {
      id: 'softener_history_event_2203',
      defaultMessage: "C3 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2204: {
      id: 'softener_history_event_2204',
      defaultMessage: "C4 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2205: {
      id: 'softener_history_event_2205',
      defaultMessage: "C5 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2206: {
      id: 'softener_history_event_2206',
      defaultMessage: "C6 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2207: {
      id: 'softener_history_event_2207',
      defaultMessage: "C7 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2208: {
      id: 'softener_history_event_2208',
      defaultMessage: "C8 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2209: {
      id: 'softener_history_event_2209',
      defaultMessage: "C9 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2210: {
      id: 'softener_history_event_2210',
      defaultMessage: "C10 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2211: {
      id: 'softener_history_event_2211',
      defaultMessage: "C11 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2212: {
      id: 'softener_history_event_2212',
      defaultMessage: "C12 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2213: {
      id: 'softener_history_event_2213',
      defaultMessage: "C13 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2214: {
      id: 'softener_history_event_2214',
      defaultMessage: "C14 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2215: {
      id: 'softener_history_event_2215',
      defaultMessage: "C15 cycle for C cylinder",
      description: '',
    },
    softener_history_event_2301: {
      id: 'softener_history_event_2301',
      defaultMessage: "C1 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2302: {
      id: 'softener_history_event_2302',
      defaultMessage: "C2 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2303: {
      id: 'softener_history_event_2303',
      defaultMessage: "C3 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2304: {
      id: 'softener_history_event_2304',
      defaultMessage: "C4 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2305: {
      id: 'softener_history_event_2305',
      defaultMessage: "C5 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2306: {
      id: 'softener_history_event_2306',
      defaultMessage: "C6 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2307: {
      id: 'softener_history_event_2307',
      defaultMessage: "C7 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2308: {
      id: 'softener_history_event_2308',
      defaultMessage: "C8 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2309: {
      id: 'softener_history_event_2309',
      defaultMessage: "C9 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2310: {
      id: 'softener_history_event_2310',
      defaultMessage: "C10 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2311: {
      id: 'softener_history_event_2311',
      defaultMessage: "C11 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2312: {
      id: 'softener_history_event_2312',
      defaultMessage: "C12 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2313: {
      id: 'softener_history_event_2313',
      defaultMessage: "C13 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2314: {
      id: 'softener_history_event_2314',
      defaultMessage: "C14 cycle for B cylinder",
      description: '',
    },
    softener_history_event_2315: {
      id: 'softener_history_event_2315',
      defaultMessage: "C15 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3101: {
      id: 'softener_history_event_3101',
      defaultMessage: "CU1 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3102: {
      id: 'softener_history_event_3102',
      defaultMessage: "CU2 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3103: {
      id: 'softener_history_event_3103',
      defaultMessage: "CU3 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3104: {
      id: 'softener_history_event_3104',
      defaultMessage: "CU4 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3105: {
      id: 'softener_history_event_3105',
      defaultMessage: "CU5 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3106: {
      id: 'softener_history_event_3106',
      defaultMessage: "CU6 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3107: {
      id: 'softener_history_event_3107',
      defaultMessage: "CU7 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3108: {
      id: 'softener_history_event_3108',
      defaultMessage: "CU8 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3109: {
      id: 'softener_history_event_3109',
      defaultMessage: "CU9 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3110: {
      id: 'softener_history_event_3110',
      defaultMessage: "CU10 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3111: {
      id: 'softener_history_event_3111',
      defaultMessage: "CU11 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3112: {
      id: 'softener_history_event_3112',
      defaultMessage: "CU12 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3113: {
      id: 'softener_history_event_3113',
      defaultMessage: "CU13 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3114: {
      id: 'softener_history_event_3114',
      defaultMessage: "CU14 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3115: {
      id: 'softener_history_event_3115',
      defaultMessage: "CU15 cycle for A cylinder",
      description: '',
    },
    softener_history_event_3201: {
      id: 'softener_history_event_3201',
      defaultMessage: "CU1 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3202: {
      id: 'softener_history_event_3202',
      defaultMessage: "CU2 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3203: {
      id: 'softener_history_event_3203',
      defaultMessage: "CU3 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3204: {
      id: 'softener_history_event_3204',
      defaultMessage: "CU4 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3205: {
      id: 'softener_history_event_3205',
      defaultMessage: "CU5 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3206: {
      id: 'softener_history_event_3206',
      defaultMessage: "CU6 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3207: {
      id: 'softener_history_event_3207',
      defaultMessage: "CU7 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3208: {
      id: 'softener_history_event_3208',
      defaultMessage: "CU8 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3209: {
      id: 'softener_history_event_3209',
      defaultMessage: "CU9 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3210: {
      id: 'softener_history_event_3210',
      defaultMessage: "CU10 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3211: {
      id: 'softener_history_event_3211',
      defaultMessage: "CU11 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3212: {
      id: 'softener_history_event_3212',
      defaultMessage: "CU12 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3213: {
      id: 'softener_history_event_3213',
      defaultMessage: "CU13 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3214: {
      id: 'softener_history_event_3214',
      defaultMessage: "CU14 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3215: {
      id: 'softener_history_event_3215',
      defaultMessage: "CU15 cycle for C cylinder",
      description: '',
    },
    softener_history_event_3301: {
      id: 'softener_history_event_3301',
      defaultMessage: "CU1 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3302: {
      id: 'softener_history_event_3302',
      defaultMessage: "CU2 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3303: {
      id: 'softener_history_event_3303',
      defaultMessage: "CU3 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3304: {
      id: 'softener_history_event_3304',
      defaultMessage: "CU4 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3305: {
      id: 'softener_history_event_3305',
      defaultMessage: "CU5 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3306: {
      id: 'softener_history_event_3306',
      defaultMessage: "CU6 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3307: {
      id: 'softener_history_event_3307',
      defaultMessage: "CU7 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3308: {
      id: 'softener_history_event_3308',
      defaultMessage: "CU8 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3309: {
      id: 'softener_history_event_3309',
      defaultMessage: "CU9 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3310: {
      id: 'softener_history_event_3310',
      defaultMessage: "CU10 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3311: {
      id: 'softener_history_event_3311',
      defaultMessage: "CU11 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3312: {
      id: 'softener_history_event_3312',
      defaultMessage: "CU12 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3313: {
      id: 'softener_history_event_3313',
      defaultMessage: "CU13 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3314: {
      id: 'softener_history_event_3314',
      defaultMessage: "CU14 cycle for B cylinder",
      description: '',
    },
    softener_history_event_3315: {
      id: 'softener_history_event_3315',
      defaultMessage: "CU15 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4101: {
      id: 'softener_history_event_4101',
      defaultMessage: "CM1 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4102: {
      id: 'softener_history_event_4102',
      defaultMessage: "CM2 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4103: {
      id: 'softener_history_event_4103',
      defaultMessage: "CM3 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4104: {
      id: 'softener_history_event_4104',
      defaultMessage: "CM4 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4105: {
      id: 'softener_history_event_4105',
      defaultMessage: "CM5 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4106: {
      id: 'softener_history_event_4106',
      defaultMessage: "CM6 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4107: {
      id: 'softener_history_event_4107',
      defaultMessage: "CM7 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4108: {
      id: 'softener_history_event_4108',
      defaultMessage: "CM8 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4109: {
      id: 'softener_history_event_4109',
      defaultMessage: "CM9 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4110: {
      id: 'softener_history_event_4110',
      defaultMessage: "CM10 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4111: {
      id: 'softener_history_event_4111',
      defaultMessage: "CM11 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4112: {
      id: 'softener_history_event_4112',
      defaultMessage: "CM12 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4113: {
      id: 'softener_history_event_4113',
      defaultMessage: "CM13 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4114: {
      id: 'softener_history_event_4114',
      defaultMessage: "CM14 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4115: {
      id: 'softener_history_event_4115',
      defaultMessage: "CM15 cycle for A cylinder",
      description: '',
    },
    softener_history_event_4201: {
      id: 'softener_history_event_4201',
      defaultMessage: "CM1 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4202: {
      id: 'softener_history_event_4202',
      defaultMessage: "CM2 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4203: {
      id: 'softener_history_event_4203',
      defaultMessage: "CM3 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4204: {
      id: 'softener_history_event_4204',
      defaultMessage: "CM4 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4205: {
      id: 'softener_history_event_4205',
      defaultMessage: "CM5 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4206: {
      id: 'softener_history_event_4206',
      defaultMessage: "CM6 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4207: {
      id: 'softener_history_event_4207',
      defaultMessage: "CM7 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4208: {
      id: 'softener_history_event_4208',
      defaultMessage: "CM8 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4209: {
      id: 'softener_history_event_4209',
      defaultMessage: "CM9 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4210: {
      id: 'softener_history_event_4210',
      defaultMessage: "CM10 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4211: {
      id: 'softener_history_event_4211',
      defaultMessage: "CM11 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4212: {
      id: 'softener_history_event_4212',
      defaultMessage: "CM12 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4213: {
      id: 'softener_history_event_4213',
      defaultMessage: "CM13 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4214: {
      id: 'softener_history_event_4214',
      defaultMessage: "CM14 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4215: {
      id: 'softener_history_event_4215',
      defaultMessage: "CM15 cycle for C cylinder",
      description: '',
    },
    softener_history_event_4301: {
      id: 'softener_history_event_4301',
      defaultMessage: "CM1 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4302: {
      id: 'softener_history_event_4302',
      defaultMessage: "CM2 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4303: {
      id: 'softener_history_event_4303',
      defaultMessage: "CM3 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4304: {
      id: 'softener_history_event_4304',
      defaultMessage: "CM4 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4305: {
      id: 'softener_history_event_4305',
      defaultMessage: "CM5 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4306: {
      id: 'softener_history_event_4306',
      defaultMessage: "CM6 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4307: {
      id: 'softener_history_event_4307',
      defaultMessage: "CM7 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4308: {
      id: 'softener_history_event_4308',
      defaultMessage: "CM8 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4309: {
      id: 'softener_history_event_4309',
      defaultMessage: "CM9 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4310: {
      id: 'softener_history_event_4310',
      defaultMessage: "CM10 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4311: {
      id: 'softener_history_event_4311',
      defaultMessage: "CM11 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4312: {
      id: 'softener_history_event_4312',
      defaultMessage: "CM12 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4313: {
      id: 'softener_history_event_4313',
      defaultMessage: "CM13 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4314: {
      id: 'softener_history_event_4314',
      defaultMessage: "CM14 cycle for B cylinder",
      description: '',
    },
    softener_history_event_4315: {
      id: 'softener_history_event_4315',
      defaultMessage: "CM15 cycle for B cylinder",
      description: '',
    },
    filter_from_checboxes_history: {
      id: 'filter_from_checboxes_history',
      defaultMessage: "Filter history by checked options above",
      description: '',
    },
    multiple_select_history: {
      id: 'multiple_select_history',
      defaultMessage: "Hold down the Ctrl (windows) / Command (Mac) button to select multiple events",
      description: '',
    },
    reset_selection_history: {
      id: 'reset_selection_history',
      defaultMessage: "Show all",
      description: '',
    },
    filter_select_button_history: {
      id: 'filter_select_button_history',
      defaultMessage: "Filter",
      description: '',
    },
    clear_filter_button_history: {
      id: 'clear_filter_button_history',
      defaultMessage: "Clear fiilter",
      description: '',
    },
    save_all_as_pdf_button_history: {
      id: 'save_all_as_pdf_button_history',
      defaultMessage: "Save all record in PDF",
      description: '',
    },
    save_as_pdf_button_history: {
      id: 'save_as_pdf_button_history',
      defaultMessage: "Save shown records in PDF",
      description: '',
    },
    history_events_event_filtering_header_text: {
      id: 'history_events_event_filtering_header_text',
      defaultMessage: "Events filtering",
      description: '',
    },
    history_events_power_header_text: {
      id: 'history_events_power_header_text',
      defaultMessage: "Power",
      description: '',
    },
    history_events_cyclic_saves_header_text: {
      id: 'history_events_cyclic_saves_header_text',
      defaultMessage: "Cyclic saves",
      description: '',
    },
    history_events_alarms_header_text: {
      id: 'history_events_alarms_header_text',
      defaultMessage: "Alarms",
      description: '',
    },
    no_key: {
      id: 'no_key',
      defaultMessage: "Pressure",
      description: '',
    },
    no_key1: {
      id: 'no_key1',
      defaultMessage: "Salt",
      description: '',
    },
    no_key2: {
      id: 'no_key2',
      defaultMessage: "Network",
      description: '',
    },
    no_key3: {
      id: 'no_key3',
      defaultMessage: "Parameters modifications",
      description: '',
    },
    no_key4: {
      id: 'no_key4',
      defaultMessage: "Regenerations",
      description: '',
    },
    no_key5: {
      id: 'no_key5',
      defaultMessage: "Filter",
      description: '',
    },
    no_key6: {
      id: 'no_key6',
      defaultMessage: "Delete filter",
      description: '',
    },
    no_key7: {
      id: 'no_key7',
      defaultMessage: "Number of events in the file",
      description: '',
    },
    no_key8: {
      id: 'no_key8',
      defaultMessage: "Open",
      description: '',
    },
    history_events_header_time: {
      id: 'history_events_header_time',
      defaultMessage: "Time",
      description: '',
    },
    history_events_header_event: {
      id: 'history_events_header_event',
      defaultMessage: "Event",
      description: '',
    },
    history_events_header_flows: {
      id: 'history_events_header_flows',
      defaultMessage: "Flows",
      description: '',
    },
    history_events_header_pressure: {
      id: 'history_events_header_pressure',
      defaultMessage: "Pressures",
      description: '',
    },
    history_events_header_regenerations: {
      id: 'history_events_header_regenerations',
      defaultMessage: "Regenerations",
      description: '',
    },
    history_events_header_cylinder_reserve: {
      id: 'history_events_header_cylinder_reserve',
      defaultMessage: "Cylinder reserves",
      description: '',
    },
    history_events_header_network: {
      id: 'history_events_header_network',
      defaultMessage: "Network",
      description: '',
    },
    history_events_date: {
      id: 'history_events_date',
      defaultMessage: "Date",
      description: '',
    },
    history_events_time: {
      id: 'history_events_time',
      defaultMessage: "Time",
      description: '',
    },
    history_events_event: {
      id: 'history_events_event',
      defaultMessage: "Event",
      description: '',
    },
    history_events_daily_water_usage: {
      id: 'history_events_daily_water_usage',
      defaultMessage: "Daily water usage [l]",
      description: '',
    },
    history_events_weekly_water_usage: {
      id: 'history_events_weekly_water_usage',
      defaultMessage: "Weekly water usage [l]",
      description: '',
    },
    history_events_monthly_water_usage: {
      id: 'history_events_monthly_water_usage',
      defaultMessage: "Monthly water usage [l]",
      description: '',
    },
    history_events_total_water_usage: {
      id: 'history_events_total_water_usage',
      defaultMessage: "Total water usage [l]",
      description: '',
    },
    history_events_untreated_water_flow: {
      id: 'history_events_untreated_water_flow',
      defaultMessage: "Untreated water flow [l]",
      description: '',
    },
    history_events_water_flow: {
      id: 'history_events_water_flow',
      defaultMessage: "Water flow in case of the excessive water flow [l]",
      description: '',
    },
    history_events_water_pressure: {
      id: 'history_events_water_pressure',
      defaultMessage: "Water pressure [bar]",
      description: '',
    },
    history_events_max_water_pressure: {
      id: 'history_events_max_water_pressure',
      defaultMessage: "Maximum water pressure [bar]",
      description: '',
    },
    history_events_min_water_pressure: {
      id: 'history_events_min_water_pressure',
      defaultMessage: "Minimum water pressure [bar]",
      description: '',
    },
    history_events_max_water_flow: {
      id: 'history_events_max_water_flow',
      defaultMessage: "Maximum water flow [l/min]",
      description: '',
    },
    history_events_normal_regeneration_number: {
      id: 'history_events_normal_regeneration_number',
      defaultMessage: "Normal regenerations number",
      description: '',
    },
    history_events_service_regeneration_number: {
      id: 'history_events_service_regeneration_number',
      defaultMessage: "Service regenerations number",
      description: '',
    },
    history_events_incomplete_regeneration_number: {
      id: 'history_events_incomplete_regeneration_number',
      defaultMessage: "Incomplete regenerations number",
      description: '',
    },
    history_events_holiday_regeneration_number: {
      id: 'history_events_holiday_regeneration_number',
      defaultMessage: "Holiday regenerations number",
      description: '',
    },
    history_events_multi_regeneration_number: {
      id: 'history_events_multi_regeneration_number',
      defaultMessage: "Multi-regenerations number",
      description: '',
    },
    history_events_b1_cylinder_reserve: {
      id: 'history_events_b1_cylinder_reserve',
      defaultMessage: "B1 cylinder reserve",
      description: '',
    },
    history_events_b2_cylinder_reserve: {
      id: 'history_events_b2_cylinder_reserve',
      defaultMessage: "B2 cylinder reserve",
      description: '',
    },
    history_events_b3_cylinder_reserve: {
      id: 'history_events_b3_cylinder_reserve',
      defaultMessage: "B3 cylinder reserve",
      description: '',
    },
    history_events_a_cylinder_reserve: {
      id: 'history_events_a_cylinder_reserve',
      defaultMessage: "A cylinder reserve [l]",
      description: '',
    },
    history_events_b_cylinder_reserve: {
      id: 'history_events_b_cylinder_reserve',
      defaultMessage: "B cylinder reserve [l]",
      description: '',
    },
    history_events_c_cylinder_reserve: {
      id: 'history_events_c_cylinder_reserve',
      defaultMessage: "C cylinder reserve [l]",
      description: '',
    },
    history_events_chlor_current: {
      id: 'history_events_chlor_current',
      defaultMessage: "Chlor current [mA]",
      description: '',
    },
    history_events_ip_address: {
      id: 'history_events_ip_address',
      defaultMessage: "IP address",
      description: '',
    },
    history_events_subnet_mask: {
      id: 'history_events_subnet_mask',
      defaultMessage: "Subnet mask",
      description: '',
    },
    history_events_default_gateway: {
      id: 'history_events_default_gateway',
      defaultMessage: "Default Gateway",
      description: '',
    },
    history_events_device_operator: {
      id: 'history_events_device_operator',
      defaultMessage: "Device operator",
      description: '',
    },
    history_events_record_no: {
      id: 'history_events_record_no',
      defaultMessage: "Record no.",
      description: '',
    },
    record_part1_text: {
      id: 'record_part1_text',
      defaultMessage: "You see",
      description: '',
    },
    record_part2_text: {
      id: 'record_part2_text',
      defaultMessage: "records",
      description: '',
    },
    history_parameters_superior_date: {
      id: 'history_parameters_superior_date',
      defaultMessage: "Date",
      description: '',
    },
    history_parameters_superior_time: {
      id: 'history_parameters_superior_time',
      defaultMessage: "Time",
      description: '',
    },
    history_parameters_superior_language: {
      id: 'history_parameters_superior_language',
      defaultMessage: "Language",
      description: '',
    },
    history_parameters_superior_device_type: {
      id: 'history_parameters_superior_device_type',
      defaultMessage: "Device type",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_enable: {
      id: 'history_parameters_superior_auto_degass_start_1_enable',
      defaultMessage: "Auto Degass Start 1 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_hour: {
      id: 'history_parameters_superior_auto_degass_start_1_hour',
      defaultMessage: "Auto Degass Start 1 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_minute: {
      id: 'history_parameters_superior_auto_degass_start_1_minute',
      defaultMessage: "Auto Degass Start 1 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_enable: {
      id: 'history_parameters_superior_auto_degass_stop_1_enable',
      defaultMessage: "Auto Degass Stop 1 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_hour: {
      id: 'history_parameters_superior_auto_degass_stop_1_hour',
      defaultMessage: "Auto Degass Stop 1 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_minute: {
      id: 'history_parameters_superior_auto_degass_stop_1_minute',
      defaultMessage: "Auto Degass Stop 1 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_enable: {
      id: 'history_parameters_superior_auto_degass_start_2_enable',
      defaultMessage: "Auto Degass Start 2 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_hour: {
      id: 'history_parameters_superior_auto_degass_start_2_hour',
      defaultMessage: "Auto Degass Start 2 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_minute: {
      id: 'history_parameters_superior_auto_degass_start_2_minute',
      defaultMessage: "Auto Degass Start 2 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_enable: {
      id: 'history_parameters_superior_auto_degass_stop_2_enable',
      defaultMessage: "Auto Degass Stop 2 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_hour: {
      id: 'history_parameters_superior_auto_degass_stop_2_hour',
      defaultMessage: "Auto Degass Stop 2 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_minute: {
      id: 'history_parameters_superior_auto_degass_stop_2_minute',
      defaultMessage: "Auto Degass Stop 2 - minute",
      description: '',
    },
    history_parameters_superior_degass_block: {
      id: 'history_parameters_superior_degass_block',
      defaultMessage: "Degassing blocking weekday",
      description: '',
    },
    history_events_superior_header_time: {
      id: 'history_events_superior_header_time',
      defaultMessage: "Time",
      description: '',
    },
    history_events_superior_header_event: {
      id: 'history_events_superior_header_event',
      defaultMessage: "Events",
      description: '',
    },
    history_events_superior_header_flow: {
      id: 'history_events_superior_header_flow',
      defaultMessage: "Flows",
      description: '',
    },
    history_events_superior_header_other: {
      id: 'history_events_superior_header_other',
      defaultMessage: "Other",
      description: '',
    },
    history_events_superior_date: {
      id: 'history_events_superior_date',
      defaultMessage: "Date",
      description: '',
    },
    history_events_superior_time: {
      id: 'history_events_superior_time',
      defaultMessage: "Time",
      description: '',
    },
    history_events_superior_event: {
      id: 'history_events_superior_event',
      defaultMessage: "Event",
      description: '',
    },
    history_events_superior_current_refill_flow: {
      id: 'history_events_superior_current_refill_flow',
      defaultMessage: "Current refill flow [l]",
      description: '',
    },
    history_events_superior_refill_flow_rate: {
      id: 'history_events_superior_refill_flow_rate',
      defaultMessage: "Refill flow rate [l/min]",
      description: '',
    },
    history_events_superior_total_refill_volume: {
      id: 'history_events_superior_total_refill_volume',
      defaultMessage: "Total refill volume [l]",
      description: '',
    },
    history_events_superior_system_pressure: {
      id: 'history_events_superior_system_pressure',
      defaultMessage: "System pressure [bar]",
      description: '',
    },
    history_events_superior_total_refill_time: {
      id: 'history_events_superior_total_refill_time',
      defaultMessage: "Total refill time [min]",
      description: '',
    },
    history_events_superior_total_degass_time: {
      id: 'history_events_superior_total_degass_time',
      defaultMessage: "Total degass time [min]",
      description: '',
    },
    history_events_superior_device_operator: {
      id: 'history_events_superior_device_operator',
      defaultMessage: "Device operator",
      description: '',
    },
    history_events_superior_record_no: {
      id: 'history_events_superior_record_no',
      defaultMessage: "Record no.",
      description: '',
    },
    history_pressures_superior_t_psys: {
      id: 'history_pressures_superior_t_psys',
      defaultMessage: "t[Psys]",
      description: '',
    },
    history_pressures_superior_psys: {
      id: 'history_pressures_superior_psys',
      defaultMessage: "Psys",
      description: '',
    },
    history_pressures_superior_t_pmin: {
      id: 'history_pressures_superior_t_pmin',
      defaultMessage: "t[Pmin]",
      description: '',
    },
    history_pressures_superior_pmin: {
      id: 'history_pressures_superior_pmin',
      defaultMessage: "Pmin",
      description: '',
    },
    history_pressures_superior_t_pzero: {
      id: 'history_pressures_superior_t_pzero',
      defaultMessage: "t[Pflushperiodstart]",
      description: '',
    },
    history_pressures_superior_pzero: {
      id: 'history_pressures_superior_pzero',
      defaultMessage: "Pflushperiodstart",
      description: '',
    },
    history_pressures_superior_t_pflush: {
      id: 'history_pressures_superior_t_pflush',
      defaultMessage: "t[Pflush]",
      description: '',
    },
    history_pressures_superior_pflush: {
      id: 'history_pressures_superior_pflush',
      defaultMessage: "Pflush",
      description: '',
    },
    superior_history_event_0001: {
      id: 'superior_history_event_0001',
      defaultMessage: "Power ON",
      description: '',
    },
    superior_history_event_0002: {
      id: 'superior_history_event_0002',
      defaultMessage: "Power OFF",
      description: '',
    },
    superior_history_event_0003: {
      id: 'superior_history_event_0003',
      defaultMessage: "Silent reset",
      description: '',
    },
    superior_history_event_0004: {
      id: 'superior_history_event_0004',
      defaultMessage: "Device enabled",
      description: '',
    },
    superior_history_event_0005: {
      id: 'superior_history_event_0005',
      defaultMessage: "Device disabled",
      description: '',
    },
    superior_history_event_0006: {
      id: 'superior_history_event_0006',
      defaultMessage: "Reboot",
      description: '',
    },
    superior_history_event_0010: {
      id: 'superior_history_event_0010',
      defaultMessage: "Degassing started",
      description: '',
    },
    superior_history_event_0011: {
      id: 'superior_history_event_0011',
      defaultMessage: "Degassing stopped",
      description: '',
    },
    superior_history_event_0012: {
      id: 'superior_history_event_0012',
      defaultMessage: "Refilling started",
      description: '',
    },
    superior_history_event_0121: {
      id: 'superior_history_event_0121',
      defaultMessage: "Ext. refilling",
      description: '',
    },
    superior_history_event_0122: {
      id: 'superior_history_event_0122',
      defaultMessage: "BMS refilling",
      description: '',
    },
    superior_history_event_0013: {
      id: 'superior_history_event_0013',
      defaultMessage: "Refilling stopped",
      description: '',
    },
    superior_history_event_0014: {
      id: 'superior_history_event_0014',
      defaultMessage: "Initial filling",
      description: '',
    },
    superior_history_event_0015: {
      id: 'superior_history_event_0015',
      defaultMessage: "System filling",
      description: '',
    },
    superior_history_event_0016: {
      id: 'superior_history_event_0016',
      defaultMessage: "Pump test started",
      description: '',
    },
    superior_history_event_0018: {
      id: 'superior_history_event_0018',
      defaultMessage: "Low pressure",
      description: '',
    },
    superior_history_event_0019: {
      id: 'superior_history_event_0019',
      defaultMessage: "High pressure",
      description: '',
    },
    superior_history_event_0021: {
      id: 'superior_history_event_0021',
      defaultMessage: "User menu modificated",
      description: '',
    },
    superior_history_event_0022: {
      id: 'superior_history_event_0022',
      defaultMessage: "Advanced menu modificated",
      description: '',
    },
    superior_history_event_0023: {
      id: 'superior_history_event_0023',
      defaultMessage: "Device type changed",
      description: '',
    },
    superior_history_event_0034: {
      id: 'superior_history_event_0034',
      defaultMessage: "Clock changed - before",
      description: '',
    },
    superior_history_event_0035: {
      id: 'superior_history_event_0035',
      defaultMessage: "Clock changed - after",
      description: '',
    },
    superior_history_event_0036: {
      id: 'superior_history_event_0036',
      defaultMessage: "Timezone changed",
      description: '',
    },
    superior_history_event_0037: {
      id: 'superior_history_event_0037',
      defaultMessage: "Manual work enabled",
      description: '',
    },
    superior_history_event_0040: {
      id: 'superior_history_event_0040',
      defaultMessage: "Network connected",
      description: '',
    },
    superior_history_event_0041: {
      id: 'superior_history_event_0041',
      defaultMessage: "Network disconnected",
      description: '',
    },
    superior_history_event_0042: {
      id: 'superior_history_event_0042',
      defaultMessage: "DHCP address assigned",
      description: '',
    },
    superior_history_event_0043: {
      id: 'superior_history_event_0043',
      defaultMessage: "Manual network assigned",
      description: '',
    },
    superior_history_event_0044: {
      id: 'superior_history_event_0044',
      defaultMessage: "Connected to internet service",
      description: '',
    },
    superior_history_event_0045: {
      id: 'superior_history_event_0045',
      defaultMessage: "Firmware upgrade request",
      description: '',
    },
    superior_history_event_0046: {
      id: 'superior_history_event_0046',
      defaultMessage: "Factory reset",
      description: '',
    },
    superior_history_event_0050: {
      id: 'superior_history_event_0050',
      defaultMessage: "Error clear",
      description: '',
    },
    superior_history_event_0051: {
      id: 'superior_history_event_0051',
      defaultMessage: "Commissioning test started",
      description: '',
    },
    superior_history_event_0052: {
      id: 'superior_history_event_0052',
      defaultMessage: "Commissioning test passed",
      description: '',
    },
    superior_history_event_0053: {
      id: 'superior_history_event_0053',
      defaultMessage: "Commissioning test failed",
      description: '',
    },
    superior_history_event_0400: {
      id: 'superior_history_event_0400',
      defaultMessage: "No error",
      description: '',
    },
    superior_history_event_0401: {
      id: 'superior_history_event_0401',
      defaultMessage: "System pressure too low",
      description: '',
    },
    superior_history_event_0402: {
      id: 'superior_history_event_0402',
      defaultMessage: "System pressure too high",
      description: '',
    },
    superior_history_event_0403: {
      id: 'superior_history_event_0403',
      defaultMessage: "Too low water temperature",
      description: '',
    },
    superior_history_event_0404: {
      id: 'superior_history_event_0404',
      defaultMessage: "Too high water temperature",
      description: '',
    },
    superior_history_event_0405: {
      id: 'superior_history_event_0405',
      defaultMessage: "Input flow blocked",
      description: '',
    },
    superior_history_event_0406: {
      id: 'superior_history_event_0406',
      defaultMessage: "Low level vessel repeatedly",
      description: '',
    },
    superior_history_event_0407: {
      id: 'superior_history_event_0407',
      defaultMessage: "Low level vessel",
      description: '',
    },
    superior_history_event_0408: {
      id: 'superior_history_event_0408',
      defaultMessage: "Main pump overheated",
      description: '',
    },
    superior_history_event_0409: {
      id: 'superior_history_event_0409',
      defaultMessage: "Main pump overload",
      description: '',
    },
    superior_history_event_0410: {
      id: 'superior_history_event_0410',
      defaultMessage: "Refill flow too low",
      description: '',
    },
    superior_history_event_0411: {
      id: 'superior_history_event_0411',
      defaultMessage: "Refill valve open",
      description: '',
    },
    superior_history_event_0412: {
      id: 'superior_history_event_0412',
      defaultMessage: "Unknown errror",
      description: '',
    },
    superior_history_event_0413: {
      id: 'superior_history_event_0413',
      defaultMessage: "Refill: too often",
      description: '',
    },
    superior_history_event_0414: {
      id: 'superior_history_event_0414',
      defaultMessage: "Refill: too long",
      description: '',
    },
    superior_history_event_0415: {
      id: 'superior_history_event_0415',
      defaultMessage: "Refill: too much",
      description: '',
    },
    superior_history_event_0416: {
      id: 'superior_history_event_0416',
      defaultMessage: "Unknown errror",
      description: '',
    },
    superior_history_event_0417: {
      id: 'superior_history_event_0417',
      defaultMessage: "Wrong phase order",
      description: '',
    },
    superior_history_event_0418: {
      id: 'superior_history_event_0418',
      defaultMessage: "Too big output pressure",
      description: '',
    },
    superior_history_event_0419: {
      id: 'superior_history_event_0419',
      defaultMessage: "Pressure sensor fault",
      description: '',
    },
    superior_history_event_0420: {
      id: 'superior_history_event_0420',
      defaultMessage: "Fuse 2 broken",
      description: '',
    },
    superior_history_event_0421: {
      id: 'superior_history_event_0421',
      defaultMessage: "Fuse 3 broken",
      description: '',
    },
    superior_history_event_0422: {
      id: 'superior_history_event_0422',
      defaultMessage: "Communication fault",
      description: '',
    },
    superior_history_event_0423: {
      id: 'superior_history_event_0423',
      defaultMessage: "Too low expansion vessel",
      description: '',
    },
    superior_history_event_0424: {
      id: 'superior_history_event_0424',
      defaultMessage: "Low level break tank",
      description: '',
    },
    superior_history_event_0425: {
      id: 'superior_history_event_0425',
      defaultMessage: "Pump error",
      description: '',
    },
    superior_history_event_0426: {
      id: 'superior_history_event_0426',
      defaultMessage: "Unknown error",
      description: '',
    },
    superior_history_event_0427: {
      id: 'superior_history_event_0427',
      defaultMessage: "Unknown error",
      description: '',
    },
    superior_history_event_0428: {
      id: 'superior_history_event_0428',
      defaultMessage: "Unknown error",
      description: '',
    },
    superior_history_event_0429: {
      id: 'superior_history_event_0429',
      defaultMessage: "Unknown error",
      description: '',
    },
    superior_history_event_0430: {
      id: 'superior_history_event_0430',
      defaultMessage: "Inlet blocked",
      description: '',
    },
    superior_history_event_0431: {
      id: 'superior_history_event_0431',
      defaultMessage: "Fill time too long",
      description: '',
    },
    superior_history_event_0432: {
      id: 'superior_history_event_0432',
      defaultMessage: "Pressure drop inlet too high",
      description: '',
    },
    superior_history_event_0433: {
      id: 'superior_history_event_0433',
      defaultMessage: "Pressure drop inlet too low",
      description: '',
    },
    superior_history_event_0434: {
      id: 'superior_history_event_0434',
      defaultMessage: "SmartSwitch broken",
      description: '',
    },
    superior_history_event_0435: {
      id: 'superior_history_event_0435',
      defaultMessage: "Solenoid valve does not close",
      description: '',
    },
    superior_history_event_0436: {
      id: 'superior_history_event_0436',
      defaultMessage: "Undesirable air intake",
      description: '',
    },
    superior_history_event_0437: {
      id: 'superior_history_event_0437',
      defaultMessage: "Incompressible system",
      description: '',
    },
    superior_history_event_0438: {
      id: 'superior_history_event_0438',
      defaultMessage: "Incompressible system",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/Messages.js